import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicDomainServicesSummaryParamsRaw,
	LWApiPublicDomainServicesSummaryResultRaw,
} from '@liquidweb-dev/club-sauce/public/domain/services/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const DOMAIN_SERVICES_SUMMARY_QUERY_KEY = '/domain/services/summary';

const useDomainServicesSummary = <
	TSelectedData = LWApiPublicDomainServicesSummaryResultRaw,
>(
	params: LWApiPublicDomainServicesSummaryParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicDomainServicesSummaryResultRaw,
		ApiErrorI,
		TSelectedData
	>,
) =>
	useQuery({
		queryKey: [DOMAIN_SERVICES_SUMMARY_QUERY_KEY, params],
		queryFn: () => api.domain.services.apiRaw.summary(params),
		...options,
	});

export default useDomainServicesSummary;
